import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/guard';
import { LayoutComponent } from '../layout/layout.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CasinoComponent } from './dashboard/casino/casino.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { InPlayComponent } from './in-play/in-play.component';
import { MyBetListComponent } from './my-bet-list/my-bet-list.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { RulesComponent } from './rules/rules.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { MultiMarketComponent } from './multi-market/multi-market.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { ExposeDetailComponent } from './user/expose-detail/expose-detail.component';
import { CasinoSettingComponent } from './settings/casino-setting/casino-setting.component';
import { ICasinoSettingComponent } from './settings/i-casino-setting/i-casino-setting.component';
import { SportSettingComponent } from './settings/sport-setting/sport-setting.component';
import { UserSettingComponent } from './settings/user-setting/user-setting.component';
import { DepositComponent } from './deposit/deposit.component';
import { WithdrawComponent } from './withdraw/withdraw.component';
import { UserCreateComponent } from './user/user-create/user-create.component';
import { SettlementComponent } from './settlement/settlement.component';
import { RemovedUsersComponent } from './user/removed-users/removed-users.component';

const routes: Routes = [
  {
    path: "dashboard",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "user-create/:uid/:key",
        component: UserCreateComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "settlement/:uid",
        component: SettlementComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "balance-sheet/:uid",
        component: SettlementComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "sports/:sid",
        component: SportListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "casino",
        component: CasinoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "profile",
        component: MyProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "rules",
        component: RulesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "inplay",
        component: InPlayComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "my-bets",
        component: MyBetListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "mobile-menu",
        component: MobileMenuComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "market-analysis/:uid",
        component: MarketAnalysisComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "multi-market",
        component: MultiMarketComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/child/:uid",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/child/:uid/:key",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/blocked-child/:uid",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/blocked-child/:uid/:key",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/child_by_type/:tid",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/child_by_type/:tid/:key",
        component: UserListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "users/removed-child",
        component: RemovedUsersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "expose-detail/:uid",
        component: ExposeDetailComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "deposit/:uid",
        component: DepositComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "withdraw/:uid",
        component: WithdrawComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "user-setting/:uid",
        component: UserSettingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "casino-setting/:uid",
        component: CasinoSettingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "icasino-setting/:uid",
        component: ICasinoSettingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "sport-setting/:uid",
        component: SportSettingComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
      canActivate: [AuthGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./sports/sports.module").then((m) => m.SportsModule),
      canActivate: [AuthGuard],
  },
  // {
  //   path: "casino",
  //   loadChildren: () =>
  //     import("./casino/casino.module").then((m) => m.CasinoModule),
  //     canActivate: [AuthGuard],
  // },
  // {
  //   path: "slot",
  //   loadChildren: () =>
  //     import("./slot/slot.module").then((m) => m.SlotModule),
  //     canActivate: [AuthGuard],
  // },
  // {
  //   path: "fantasy",
  //   loadChildren: () =>
  //     import("./fantasy-games/fantasy-games.module").then((m) => m.FantasyGamesModule),
  //     canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[AuthGuard]
})
export class PagesRoutingModule { }
